// extracted by mini-css-extract-plugin
module.exports = {"container":"i_dy","item":"i_dz","left":"i_d0","right":"i_d1","wording":"i_d2","icon":"i_d3","label":"i_d4","value":"i_d5"};